// @ts-strict-ignore
import { Dictionary } from 'typescript-collections';
import { DimensionMetrics } from '@3d-scene/layer/util/dimension-metrics';

export class DimensionLevelMetricsUtil {
  public static findAvailableDimensionLevelByMetrics(dimensionsLevels: Dictionary<number, DimensionMetrics>, minX: number, maxX: number,
    startLevel: number = 1): number {
    let availableLevel: number = startLevel;
    while (dimensionsLevels.getValue(availableLevel)) {
      const dimensionMetrics: DimensionMetrics = dimensionsLevels.getValue(availableLevel);
      if (dimensionMetrics.minX > maxX) {
        break;
      }

      availableLevel++;
    }

    return availableLevel;
  }

  public static updateDimensionsLevels(dimensionsLevels: Dictionary<number, DimensionMetrics>, level: number, minX: number,
    maxX: number): void {
    if (dimensionsLevels.getValue(level)) {
      const metrics: DimensionMetrics = dimensionsLevels.getValue(level);
      metrics.minX = Math.min(minX, metrics.minX);
      metrics.maxX = Math.max(maxX, metrics.maxX);
    } else {
      dimensionsLevels.setValue(level, new DimensionMetrics(minX, maxX));
    }
  }

  public static getLastMaxXForLevel(dimensionsLevels: Dictionary<number, DimensionMetrics>, level: number,
    sizeSpacing: number = 0): number {
    let result: number = 0;

    if (dimensionsLevels.getValue(level)) {
      result = dimensionsLevels.getValue(level).maxX + sizeSpacing;
    }

    return result;
  }

  public static findFirstNotEmptyAvalibleSizeLevel(dimensionsLevels:  Dictionary<number, DimensionMetrics>, minX: number): number {
    let availableLevel: number = this.getMaxLevel(dimensionsLevels);

    while (dimensionsLevels.getValue(availableLevel) && availableLevel > 0) {
      const metrics: DimensionMetrics = dimensionsLevels.getValue(availableLevel);
      if (metrics.maxX >= minX) {
        break;
      }

      availableLevel--;
    }

    return availableLevel;
  }

  public static getMaxLevel(dimensionsLevels:  Dictionary<number, DimensionMetrics>): number {
    let maxLevel: number = 0;
    for (const level of dimensionsLevels.keys()) {
      maxLevel = Math.max(maxLevel, level);
    }
    return maxLevel;
  }
}
